import { useState, useEffect } from "react";
import { Formik, Field, Form } from "formik";
import {
    InputGroup,
    Label,
    SubmitBtn,
    SideCancelBtn,
    Wrapper,
    ScrollableContent,
    ActionSection,
} from "../Styles/InputStyles";
import { MdClose } from "react-icons/md";
import tw from "tailwind-styled-components";
import * as Yup from "yup";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import "react-datepicker/dist/react-datepicker.css";
import DropZone from "../Notice/Dropzone";

const documentSchema = Yup.object().shape({
    documentType: Yup.string().required("Document type is required"),
    file: Yup.mixed().required("File is required"),
});

const documentTypeOptions = [
    { label: "PAN Card", value: 3 },
    { label: "Aadhaar Front", value: 1 },
    { label: "Aadhaar Back", value: 2 },
];

const ViewKYCDetail = ({
    handleClose,
    documentData,
    setShowUploadForm,
    showUploadForm,
    addDocumentLoading,
    addDocumentMutate,
    selectedData
}) => {
    const hasLeaseDocs = documentData?.data?.docs ||
        (selectedData?.docs && Array.isArray(selectedData.docs) && selectedData.docs.length > 0)
        ;

    const initialDocumentValues = {
        documentType: "",
        file: null,
    };

    const [height, setHeight] = useState(window.innerHeight);

    useEffect(() => {
        const handleResize = () => {
            setHeight(window.innerHeight);
        };

        window.addEventListener("resize", handleResize);
        handleResize();

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const handleDocumentSubmit = (values) => {
        const formData = new FormData();
        formData.append("landlordId", selectedData?.id);
        formData.append("type", values.documentType);
        formData.append("files", values.file[0]);
        addDocumentMutate(formData);
    };

    return (
        <Container
            style={{
                height: `${height}px`,
                overflow: "auto",
                WebkitOverflowScrolling: "touch",
            }}
        >
            <Header>
                <Title>
                    {showUploadForm ? "Upload Document" : "Landlord Details"}
                </Title>
                <button onClick={() => {
                    setShowUploadForm(false);
                    handleClose();
                }}>
                    <MdClose color="white" size={24} />
                </button>
            </Header>

            {showUploadForm ? (
                // Upload Document Form
                <div className="px-6 h-full flex flex-col justify-between">
                    <Formik
                        initialValues={initialDocumentValues}
                        onSubmit={handleDocumentSubmit}
                        validationSchema={documentSchema}
                    >
                        {({ values, setFieldValue, errors, touched }) => (
                            <Form>
                                <ScrollableContent className="max-h-[calc(100dvh-140px)]">
                                    <Wrapper>
                                        {/* Document Type */}
                                        <InputGroup>
                                            <Label htmlFor="documentType">Document Type *</Label>
                                            <Select
                                                name="documentType"
                                                id="documentType"
                                                className="w-full px-2"
                                                value={values.documentType}
                                                onChange={(e) => {
                                                    setFieldValue("documentType", e.target.value);
                                                }}
                                                style={{ height: "46px" }}
                                                displayEmpty
                                            >
                                                <MenuItem value="" disabled>
                                                    Select document type
                                                </MenuItem>
                                                {documentTypeOptions.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                            {errors.documentType && touched.documentType && (
                                                <ErrorMessage>{errors.documentType}</ErrorMessage>
                                            )}
                                        </InputGroup>

                                        {/* File Upload */}
                                        <InputGroup>
                                            <Label htmlFor="file">Document *</Label>
                                            <FieldWrapper $select={true}>
                                                <Field
                                                    required
                                                    name="file"
                                                    type="text"
                                                    id="file"
                                                    autoComplete="off"
                                                >
                                                    {(props) => (
                                                        <DropZone
                                                            fields={props.field}
                                                            setFieldValue={props.form.setFieldValue}
                                                            componentFor="expense"
                                                            acceptedFiles="image/*,application/pdf"
                                                            File={
                                                                props.field.value
                                                                    ? [props.field.value]
                                                                    : null
                                                            }
                                                        />
                                                    )}
                                                </Field>
                                            </FieldWrapper>
                                            {errors.file && touched.file && (
                                                <ErrorMessage>{errors.file}</ErrorMessage>
                                            )}
                                        </InputGroup>
                                    </Wrapper>
                                </ScrollableContent>
                                <ActionSection>
                                    <SideCancelBtn
                                        type="button"
                                        onClick={() => setShowUploadForm(false)}
                                    >
                                        Cancel
                                    </SideCancelBtn>
                                    <SubmitBtn type="submit" disabled={addDocumentLoading}>
                                        {addDocumentLoading ? "Uploading..." : "Upload"}
                                    </SubmitBtn>
                                </ActionSection>
                            </Form>
                        )}
                    </Formik>
                </div>
            ) : (

                <>
                    <ProfileSection className="flex justify-between">
                        <UserInfo>
                            <span className="font-medium mb-0">
                                {selectedData.name || "--"}
                            </span>
                            <span className="text-sm text-gray-600">
                                #{selectedData.mobile || "--"}
                            </span>
                        </UserInfo>
                    </ProfileSection>

                    <Content>
                        <ScrollableContent>
                            <Wrappers>

                                <BtnWrapper>
                                    <SectionTitle>Documents</SectionTitle>
                                    <UploadButton
                                        type="button"
                                        onClick={() => setShowUploadForm(true)}
                                    >
                                        Upload Document
                                    </UploadButton>
                                </BtnWrapper>
                                <Section>
                                    {hasLeaseDocs ? (
                                        <div >
                                            {(documentData?.data?.docs || selectedData.docs).map((doc, index) => (
                                                <div
                                                    key={index}
                                                    className="flex items-center justify-between p-2"
                                                >
                                                    <span className="text-gray-700">
                                                        {doc.title || `Document ${index + 1}`}
                                                    </span>
                                                    <a
                                                        href={doc.value}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="text-blue-500 underline text-sm"
                                                    >
                                                        View
                                                    </a>
                                                </div>
                                            ))}
                                        </div>
                                    ) : (
                                        <div className="text-center py-4">
                                            <p className="text-gray-500">No documents uploaded</p>
                                        </div>
                                    )}
                                </Section>
                            </Wrappers>
                        </ScrollableContent>
                    </Content>
                </>
            )
            }
        </Container>
    );
};

// Styled components matching ViewDetails
const Header = tw.div`flex items-center justify-between bg-[#0078BD] py-4 px-4`;
const Wrappers = tw.div`grid gap-2 my-0`;
const Container = tw.div`bg-white w-full h-full min-h-[100vh] flex flex-col`;
const Content = tw.div`p-4 flex flex-col gap-4`;
const Title = tw.h1`text-lg md:text-xl font-medium text-center text-white`;
const Section = tw.div`border border-gray-200 p-2 rounded-lg mb-3`;
const SectionTitle = tw.h2`text-base font-medium text-gray-600 flex justify-between items-center`;
const BtnWrapper = tw.div`w-full flex items-center justify-between`;
const UserInfo = tw.div`flex flex-col`;
const ProfileSection = tw.div`flex items-center gap-3 bg-gray-100 px-4 p-4`;
const ErrorMessage = tw.div`text-red-500 text-xs mt-1`;
const UploadButton = tw.button`text-sm text-primary-color underline rounded `;
const FieldWrapper = tw.div`w-full`;

export default ViewKYCDetail;
